// extracted by mini-css-extract-plugin
export default {"OurVision":"OurVision_OurVision__DaQ-A"};